// src/pages/SocialPage.jsx
import React from "react";
import { useAuth } from "../lib/auth";
import SocialFeed from "../components/social/SocialFeed";
import {
  Home,
  Users,
  Bell,
  MessageCircle,
  Search,
} from "lucide-react";
import "../styles/social.css";

export default function SocialPage() {
  const { user } = useAuth();
  const displayName = user?.firstName || user?.email || "Membre NMS06";
  const initial = displayName.charAt(0).toUpperCase();

  return (
    <div className="social-page">

      {/* 🔵 TOPBAR VERSION FACEBOOK / NMS06 */}
      <header className="social-topbar">

        {/* Gauche : logo */} 
        <div className="social-topbar-left">
          <div className="social-logo-circle">N</div>
          <span className="social-topbar-title">Réseau NMS06</span>
        </div>

        {/* Centre : barre de recherche */} 
        <div className="social-topbar-center">
          <div className="social-search-box">
            <Search size={18} className="social-search-icon" />
            <input type="text" placeholder="Rechercher dans NMS06…" />
          </div>
        </div>

        {/* Droite : icônes + profil */} 
        <div className="social-topbar-right">
          <button className="social-icon-btn" title="Accueil">
            <Home size={20} />
          </button>
          <button className="social-icon-btn" title="Groupes">
            <Users size={20} />
          </button>
          <button className="social-icon-btn" title="Messages">
            <MessageCircle size={20} />
          </button>
          <button
            className="social-icon-btn disabled"
            title="Notifications (bientôt)"
          >
            <Bell size={20} />
          </button>

          <div className="social-user-pill">
            <div className="social-avatar-small-circle">{initial}</div>
            <span className="social-user-name">{displayName}</span>
          </div>
        </div>
      </header>

      {/* 🟦 3 COLONNES */}
      <div className="social-layout">

        {/* COLONNE GAUCHE */}
        <aside className="social-column social-left">

          {/* Profil rapide */} 
          <div className="social-card social-profile-card">
            <div className="social-avatar-big">{initial}</div>
            <div>
              <p className="social-profile-name">{displayName}</p>
              <p className="social-profile-role">
                Membre NMS06 {user?.role ? `(${user.role})` : ""}
              </p>
            </div>
          </div>

          {/* Menu */} 
          <div className="social-card social-menu-card">
            <p className="social-menu-title">Navigation</p>
            <ul>
              <li>Fil d’actualité</li>
              <li>Mes groupes (bientôt)</li>
              <li>Messages (bientôt)</li>
              <li>Notifications (bientôt)</li>
            </ul>
          </div>
        </aside>

        {/* COLONNE CENTRALE (feed) */} 
        <main className="social-column social-center">
          <SocialFeed />
        </main>

        {/* COLONNE DROITE */}
        <aside className="social-column social-right">

          {/* Infos NMS06 */} 
          <div className="social-card">
            <h3>Infos NMS06</h3>
            <p>
              Bienvenue sur votre espace social privé NMS06.
              Partagez vos idées, vos actions et vos expériences logement.
            </p>
          </div>

          {/* Groupes suggérés */} 
          <div className="social-card">
            <h3>Groupes suggérés</h3>
            <ul className="social-groups-list">
              <li>Locataires CAH</li>
              <li>Quartier des Moulins</li>
              <li>Actions juridiques NMS06</li>
            </ul>
          </div>

          {/* 🔔 Contacts – Nouvelle box à la Facebook */} 
          <div className="social-card">
            <h3>Contacts</h3>
            <p className="social-muted">(Fonctionnalité à venir)</p>

            <ul className="social-contacts-list">
              <li className="contact-item">
                <div className="contact-avatar">A</div>
                <span>Ami 1</span>
              </li>

              <li classname="contact-item">
                <div className="contact-avatar">B</div>
                <span>Ami 2</span>
              </li>

              <li className="contact-item">
                <div className="contact-avatar">C</div>
                <span>Ami 3</span>
              </li>
            </ul>
          </div>

        </aside>
      </div>
    </div>
  );
}
